const ShipViewReducer = (state = {}, action) => {
    switch (action.type) {
        case "EditAllPO": {
            return Object.assign({}, state, {
                EditAllPO: action.data,
            });
            break;
        }
        case "getPendingTaskLineItemSuccess": {
            return Object.assign({}, state, {
                PendingTaskLineItems: action.data,
            });
            break;
        }
        case "getPendingTaskSuccess": {
            return Object.assign({}, state, {
                PendingTasks: action.data,
            });
            break;
        }
        case "getOtherTaskSuccess": {
            return Object.assign({}, state, {
                OtherTasks: action.data,
            });
            break;
        }
        case "getShipDetailSuccess": {
            return Object.assign({}, state, {
                ShipDetail: action.data,
            });
            break;
        }
        case "TEFormApplicable": {
            return Object.assign({}, state, {
                TEForm: action.data,
            });
            break;
        }
        case "getShipDetailFailure": {
            return Object.assign({}, state, {
                ShipDetail: action.data,
            });
            break;
        }
        case "getIHMFullManualSuccess": {
            return Object.assign({}, state, {
                IHMFullManual: action.data,
            });
            break;
        }
        case "getIHMFullManualFailure": {
            return Object.assign({}, state, {
                IHMFullManual: action.data,
            });
            break;
        }
        case "getIHMMaintenanceSuccess": {
            return Object.assign({}, state, {
                UpdatedIHMMaintenance: action.data,
            });
            break;
        }

        case "getRevisionHistorySuccess": {
            return Object.assign({}, state, {
                RevisionHistory: action.data,
            });
            break;
        }
        case "getRevisionHistoryFailure": {
            return Object.assign({}, state, {
                RevisionHistory: action.data,
            });
            break;
        }
        case "deleteRevisionHistorySuccess": {
            return Object.assign({}, state, {
                RevisionHistoryDelete: action.data,
            });
            break;
        }
        case "deleteRevisionHistoryFailure": {
            return Object.assign({}, state, {
                RevisionHistoryDelete: action.data,
            });
            break;
        }
        case "getPOSearchDetailsSuccess": {
            return Object.assign({}, state, {
                POSearchDetails: action.data,
            });
            break;
        }
        case "getPOSearchDetailsFailure": {
            return Object.assign({}, state, {
                POSearchDetails: action.data,
            });
            break;
        }
        case "getCertificateHKCSuccess": {
            return Object.assign({}, state, {
                CertificateHKC: action.data,
            });
            break;
        }
        case "getCertificateHKCFailure": {
            return Object.assign({}, state, {
                CertificateHKC: action.data,
            });
            break;
        }
        case "getCertificateEUSRRSuccess": {
            return Object.assign({}, state, {
                CertificateEUSRR: action.data,
            });
            break;
        }
        case "TaskDetails": {
            return Object.assign({}, state, {
                TaskDetails: action.data,
            });
            break;
        }
        case "AttachmentUploadSuccess": {
            return Object.assign({}, state, {
                attachmentDetail: action.data,
            });
            break;
        }
        case "AttachmentLRUploadSuccess": {
            return Object.assign({}, state, {
                attachmentLRDetail: action.data,
            });
            break;
        }
        case "GetOtherTaskList": {
            return Object.assign({}, state, {
                otherTaskList: action.data,
            });
            break;
        }
        case "EditOtherTask": {
            return Object.assign({}, state, {
                EditTaskList: action.data,
            });
            break;
        }
        case "InventoryUploadSuccess": {
            return Object.assign({}, state, {
                inventoryDetail: action.data,
            });
            break;
        }
        case "AttachmentsUploadSuccess": {
            return Object.assign({}, state, {
                attachmentsDetail: action.data,
            });
            break;
        }
        case "getAttachmentsSuccess": {
            return Object.assign({}, state, {
                getAttachmentsDetail: action.data,
            });
            break;
        }
        case "getShipDocumentSuccess": {
            return Object.assign({}, state, {
                getShipDocument: action.data,
            });
            break;
        }
        case "getTEFormsSuccess": {
            return Object.assign({}, state, {
                getTEForms: action.data,
            });
            break;
        }
        case "getAttachmentsPDFSuccess": {
            return Object.assign({}, state, {
                getAttachmentsPDFDetail: action.data,
            });
            break;
        }
        case "ShipId": {
            return Object.assign({}, state, {
                ShipId: action.data,
            });
            break;
        }
        case "putPendingTaskSuccess": {
            return Object.assign({}, state, {
                updatePendingTask: action.data,
            });
            break;
        }
        case "putPendingTaskFailure": {
            return Object.assign({}, state, {
                updatePendingTask: action.data,
            });
            break;
        }
        case "getSixMonthReviewSuccess": {
            return Object.assign({}, state, {
                SixMonthReview: action.data,
            });
            break;
        }
        case "getSixMonthReviewFailure": {
            return Object.assign({}, state, {
                SixMonthReview: action.data,
            });
            break;
        }
        case "getSixMonthReviewsSuccess": {
            return Object.assign({}, state, {
                SixMonthReviews: action.data,
            });
            break;
        }
        case "getSixMonthReviewsFailure": {
            return Object.assign({}, state, {
                SixMonthReviews: action.data,
            });
            break;
        }
        case "postSixMonthReviewSuccess": {
            return Object.assign({}, state, {
                postSixMonthReview: action.data,
            });
            break;
        }
        case "postSixMonthReviewFailure": {
            return Object.assign({}, state, {
                postSixMonthReview: action.data,
            });
            break;
        }
        case "getClassFlagCircularsSuccess": {
            return Object.assign({}, state, {
                classFlagData: action.data,
            });
            break;
        }
        case "MaterialValidationSearch": {
            return Object.assign({}, state, {
                MaterialValidationSearch: action.data,
            });
            break;
        }
        default: {
            return state;
        }
    }
};
export default ShipViewReducer;
